module.exports = __webpack_public_path__ + "img/node.a5ae2993.png";